import { render, staticRenderFns } from "./kid.vue?vue&type=template&id=1399cb2a&scoped=true"
import script from "./kid.vue?vue&type=script&lang=js"
export * from "./kid.vue?vue&type=script&lang=js"
import style0 from "./kid.vue?vue&type=style&index=0&id=1399cb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1399cb2a",
  null
  
)

export default component.exports